// Test id concatination utility
export function tx(...args: (string | undefined | false | null)[]) {
  return args.filter((s) => !!s).join(`__`)
}
